import { MonthlyPlanName, YearlyPlanName } from '@sparemin/api-sdk';
import * as React from 'react';

import useYearlyDiscount from 'blocks/Pricing/useYearlyDiscount';
import RadioOptions from 'components/RadioOptions';
import {} from 'redux/middleware/api/plan-service';
import BillingCycleModalCost from './BillingCycleModalCost';
import BillingCycleOptionLabel from './BillingCycleOptionLabel';
import { block } from './utils';

export interface BillingCyclePlanOptions {
  monthly: MonthlyPlanName;
  yearly: YearlyPlanName;
}

export type SubscriptionDuration = keyof BillingCyclePlanOptions;

type OnChange = (value: SubscriptionDuration) => void;

export interface BillingCycleOptionsProps {
  disabled?: boolean;
  onChange: OnChange;
  options: BillingCyclePlanOptions;
  value: SubscriptionDuration;
}

const BillingCycleOptions: React.SFC<BillingCycleOptionsProps> = ({
  disabled,
  onChange,
  options,
  value,
}) => {
  const yearlyDiscountPercent = useYearlyDiscount(
    options.monthly,
    options.yearly,
  );

  return (
    <RadioOptions
      className={block('options')}
      disabled={disabled}
      listClassName={block('options-list')}
      onChange={onChange}
      optionClassName={block('option')}
      options={[
        {
          label: (
            <BillingCycleOptionLabel
              cost={
                <BillingCycleModalCost planOptions={options} period="yearly" />
              }
            >
              Billed yearly
              <span className={block('discount')}>
                SAVE {yearlyDiscountPercent}%
              </span>
            </BillingCycleOptionLabel>
          ),
          value: 'yearly',
        },
        {
          label: (
            <BillingCycleOptionLabel
              cost={
                <BillingCycleModalCost
                  planOptions={options}
                  period="monthly"
                  showLimitedTimeBadge
                  showPreviousCost
                />
              }
            >
              Billed monthly
            </BillingCycleOptionLabel>
          ),
          value: 'monthly',
        },
      ]}
      value={value}
    />
  );
};

export default BillingCycleOptions;
